import { Box, LoadingOverlay, Tooltip } from '@mantine/core'

import { AiBox, RichTextEditor, AILoader } from '@percent/domain/giving'
import { ButtonText, FormField, Text, Icon } from '@percent/lemonade'
import type { OpportunityFormDescriptionFieldProps } from './description-field.types'
import classes from './description-field.module.scss'

export function OpportunityFormDescriptionField({
  value,
  onChange,
  touched,
  setTouched,
  error,
  onBlur,

  label,
  placeholder,

  showAiContent,
  enableAiGenerateButton,
  aiGenerationStatus,
  generateOpportunity,
  aiLoaderTitle,
  aiLoaderSubtitle,
  aiGenerateInfo,
  aiUnavailable,
  aiDisclaimer,
  aiRetry,
  aiGenerate,
}: Readonly<OpportunityFormDescriptionFieldProps>) {
  return (
    <FormField
      label={label}
      necessity="required"
      status={
        touched && aiGenerationStatus !== 'pending' && error
          ? 'danger'
          : 'default'
      }
      statusMessage={error}
      data-testid="descriptionField"
    >
      <Box className={classes.descriptionContainer}>
        <LoadingOverlay
          visible={aiGenerationStatus === 'pending'}
          className={classes.aiLoadingOverlay}
          loaderProps={{
            children: (
              <AILoader title={aiLoaderTitle} subtitle={aiLoaderSubtitle} />
            ),
          }}
        />
        <RichTextEditor
          fieldName="description"
          error={aiGenerationStatus !== 'pending' && !!error && !!touched}
          placeholder={placeholder}
          content={value}
          handleBlur={(e) => {
            onBlur(e)
            setTouched()
          }}
          handleUpdate={onChange}
          bottomAddOn={
            showAiContent && (
              <AiBox className={classes.aiInfo} withIcon>
                <Box className={classes.aiInfoContent}>
                  <Box>
                    <Text size="small">
                      {aiGenerationStatus === 'error'
                        ? aiUnavailable
                        : aiGenerateInfo}
                    </Text>
                    <Tooltip
                      label={aiDisclaimer}
                      disabled={enableAiGenerateButton}
                    >
                      <div data-testid="generate-opportunity-disclaimer">
                        <Icon name="info" size={6} color="gray300" />
                      </div>
                    </Tooltip>
                  </Box>
                  <div data-testid="generate-opportunity">
                    <ButtonText
                      type="button"
                      style={{ borderRadius: '2rem' }}
                      disabled={!enableAiGenerateButton}
                      onClick={() => generateOpportunity?.()}
                    >
                      {aiGenerationStatus === 'error' ? aiRetry : aiGenerate}
                    </ButtonText>
                  </div>
                </Box>
              </AiBox>
            )
          }
        />
      </Box>
    </FormField>
  )
}
